// extracted by mini-css-extract-plugin
export default {"contentWrapper":"app_contentWrapper__RGrA5","dataContainer":"app_dataContainer__VgVD+","content":"app_content__wg62R","dataWrapper":"app_dataWrapper__32ApD"};